module.exports = __webpack_public_path__ + "img/coding_icon.46a531ac.svg";